// extracted by mini-css-extract-plugin
module.exports = {"circle":"services_circle__Fh1oH","wrapper":"services_wrapper__2a7md","contentWrapper":"services_contentWrapper__e7j98","heroText":"services_heroText__J243M"};